module.exports = __webpack_public_path__ + "img/gszz5@2x.eec33ec8.png";